
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import EmptyState from '@/components/states/EmptyState.vue';
import HardwareOfferCard from '@/views/Sessions/HardwareOffersList/HardwareOfferCard.vue';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';

export default Vue.extend({
	name: 'HardwareOffersList',
	props: {
		appOffer: { type: Object, required: true },
		hardwareOffer: { type: Object, default: null },
		runnitsOwnerSelection: { type: String, default: null },
	},
	computed: {
		...mapState([
			'hardwareOffers',
			'runnitState',
		]),
		...mapGetters([
			'mobiusEnabled',
		]),
		currRunnitsOwnerSelection () {
			// Prefer prop if provided (for static cases), otherwise use Vuex state
			if (this.runnitsOwnerSelection) {
				return this.runnitsOwnerSelection;
			}
			return (this.runnitState && this.runnitState.runnitsOwnerSelection) || RUNNITS_OWNER_SELECTION.USER;
		},
		filteredHardwareOffers () {
			if (this.mobiusEnabled) {
				// Mobius hardware docs are flagged with `mobius: true` and apply to all apps (no `apps` filter).
				return this.hardwareOffers.filter((h) => h.mobius);
			}
			return this.hardwareOffers.filter(({ apps, mobius }) => !mobius && apps.includes(this.appOffer.app));
		},
	},
	components: {
		HardwareOfferCard,
		EmptyState,
	},
});
